import { PrivateFailureCause } from "./private-cause.ts";
import { Redacted, Schema } from "effect";

export const DigestInvocationError = /* @__PURE__ */ (() => {
  class DigestInvocationError extends Schema.TaggedError<DigestInvocationError>()("DigestInvocationError", {
    message: Schema.tag("The digest invocation failed."),
    cause: PrivateFailureCause,
    status: Schema.tag(500)
  }) {}
  return DigestInvocationError;
})();
export type DigestInvocationError = InstanceType<typeof DigestInvocationError>;
export const digestInvocationError = (cause: unknown) => new DigestInvocationError({ cause: Redacted.make(cause) });
